module.exports = __webpack_public_path__ + "51de43f790bd9d30a65ce9123ad30841.MP3";